import { Button, Container, Paper, FormControl, InputLabel, Select, MenuItem, SvgIcon } from '@mui/material';
import { Send } from '@mui/icons-material';
import {
  Box, Typography, IconButton, TextField,
  Card, CardContent, Divider, Stack
} from '@mui/material';
import { Add, Remove, DeleteOutline } from '@mui/icons-material';
import ItemCarrinhoCardComponent from './ItemCarrinhoCardComponent';
import { MouseEventHandler, useContext, useState } from 'react';
import BoxComponent from '../../../../../components/Box/BoxComponent';
import ButtonComponent from '../../../../../components/Button/ButtonComponent';
import { ReactComponent as CarrinhoIcon } from "../../../../../assets/icons/carrinho.svg";
import SvgComponent from '../../../../../components/Image/SvgComponent';
import TypographyComponent from '../../../../../components/Typography/ThypographyComponent';
import { formatDinheiroToNumber, formatNumberToDinheiro } from '../../../../../utils/dinheiro';
import CarrinhoPaperComponent from './CarrinhoPaperComponent';
import { AuthContext } from '../../../../../provider/auth/AuthContext';
import EtapaCarrinhoComponent from './etapas/EtapaCarrinhoComponent';
import EtapaEnderecoEntregaComponent from './etapas/EtapaEnderecoEntregaComponent';
import EtapaFormaPgtoComponent from './etapas/EtapaFormaPgtoComponent';
import EtapaLoginComponent from './etapas/EtapaLoginComponent';
import { LoginDTO, Usuario, UsuarioEnderecos } from '../../../../../provider/auth/AuthProps';
import api from '../../../../../api/api';
import { usuarioService } from '../../../../../service/UsuarioService';
import { pedidoService } from '../../../../../service/PedidoService';
import axios from 'axios';
import { ResponseErrorDTO } from '../../../../../api/ResponseProps';
import { EmpresaContext } from '../../../../../provider/empresa/EmpresaContext';
import { PedidoDTO } from '../../../../../interface/Pedido';

interface CarrinhoProps {
  itens: any[],
  setItens: any,
  handleSubmitPedido: (pedido: PedidoDTO) => void,
  limpaCarrinho: () => void
}

//const CarrinhoComponent = ({ itens, setItens, enviaPedido, formasPagamento, formaSelecionada, onChangeFormaPagamento, tipoPedido, onChangeTipoPedido }: { itens: any[], setItens: any, enviaPedido: MouseEventHandler<HTMLButtonElement>, formasPagamento: any, formaSelecionada: string, onChangeFormaPagamento: (value: string) => void, tipoPedido: string, onChangeTipoPedido: (value: string) => void }) => {
const CarrinhoComponent = (props: CarrinhoProps) => {
  type CheckoutStep =
    | "CARRINHO"
    | "USUARIO"
    | "ENDERECO"
    | "PAGAMENTO"
    | "CONFIRMACAO";

  const { empresa } = useContext(EmpresaContext);

  const [openCarrinho, setOpenCarrinho] = useState(false);

  //const { usuario } = useContext(AuthContext);
  const [cliente, setCliente] = useState<Usuario>({
    telefone: "",
    telefoneCompleto: "",
    nome: "",
    cargo: ""
  });

  const [bloqueiaCampoUsuario, setBloqueiaCampoUsuario] = useState(true);

  const handleClickCarrinho = () => {
    setOpenCarrinho(prev => !prev);
  }

  const [endereco, setEndereco] = useState<UsuarioEnderecos>();

  /*
  const [checkoutData, setCheckoutData] = useState({
    endereco: null,
    formaPagamento: null,
    observacao: "",
  });
  */

  // OBSERVAÇÕES
  const [observacaoGeral, setObservacaoGeral] = useState<string>("");

  const handleObservacaoGeral = (observacao: string) => {
    setObservacaoGeral(observacao);
  }

  // FORMA PAGAMENTO
  const [formaPagamento, setFormaPagamento] = useState<any>();
  const [formaPgtoSelecionada, setFormaPgtoSelecionada] = useState<number>();
  const [isDinheiro, setIsDinheiro] = useState<boolean>(false);

  const handleChangeFormaPgto = (formaPgto: any, index: number) => {
    setFormaPagamento(formaPgto);
    setFormaPgtoSelecionada(index);

    if (formaPgto.nome === "Dinheiro") {
      setIsDinheiro(true);
    } else {
      setIsDinheiro(false);
    }
  }

  const handleChangeTroco = (troco: number) => {
    setFormaPagamento({
      ...formaPagamento,
      vlrTroco: troco
    });
  }

  // CALCULO TOTAL DOS ITENS
  const calcTotalItens = () => {
    return props.itens.reduce((total, item) => {
      let totalComplementos = 0;

      if (Array.isArray(item.complementos)) {
        totalComplementos += (item.complementos ?? []).reduce(
          (acc: any, complemento: any) => acc + complemento.vlrUnitario,
          0
        );
      }

      if (Array.isArray(item.complementosEspecificos)) {
        totalComplementos += (item.complementosEspecificos ?? []).reduce(
          (acc: any, complemento: any) => acc + complemento.vlrUnitario,
          0
        );
      }

      return total + ((item.vlrUnitario + totalComplementos) * item.qtd);
    }, 0);
  }

  const [step, setStep] = useState<CheckoutStep>("CARRINHO");

  const handleSubmitPedido = async () => {
    if (empresa == null) return;
    else if (formaPagamento == null) return;
    //else if (formaPagamento[formaPgtoSelecionada] == null) return;
    else if (endereco == null) return;

    props.handleSubmitPedido({
      idEmpresa: empresa.id,
      idFormaPgto: formaPagamento.id,
      formaPagamento: {
        ...formaPagamento,
        vlrTroco: formatDinheiroToNumber(formaPagamento.vlrTroco)
      },
      tipo: "DELIVERY",
      observacao: observacaoGeral,
      dadosSolicitante: cliente,
      nomeCliente: cliente.nome,
      itens: props.itens,
      endereco: endereco
    });
  }

  const nextStep = async () => {
    switch (step) {
      case "CARRINHO":
        setStep("USUARIO");
        return;

      case "USUARIO":
        setStep("ENDERECO");
        return;

      case "ENDERECO":
        setStep("PAGAMENTO");
        return;

      case "PAGAMENTO":
        await handleSubmitPedido();
        setStep("CONFIRMACAO");
        return;
    }
  };

  const renderStepContent = () => {
    switch (step) {
      case "CARRINHO":
        return (
          <EtapaCarrinhoComponent
            itens={props.itens}
            onChangeItens={(itens: any) => props.setItens(itens)}
            calculoTotalItens={calcTotalItens()}
            observacaoGeral={observacaoGeral}
            onChangeObservacaoGeral={(observacao: string) => handleObservacaoGeral(observacao)}
          />
        );

      case "USUARIO":
        return (
          <EtapaLoginComponent
            telefone={cliente.telefoneCompleto}
            onChangeTelefone={(telefone: string) => getDadosUsuario(telefone)}
            nomeUsuario={cliente.nome}
            onChangeNomeUsuario={(nome: string) => setCliente({ ...cliente, nome: nome })}
            bloqueiaCampoUsuario={bloqueiaCampoUsuario}
          />
        );

      case "ENDERECO":
        return (
          <EtapaEnderecoEntregaComponent
            enderecoSelecionado={(endereco: UsuarioEnderecos) => setEndereco(endereco)}
          />
        );

      case "PAGAMENTO":
        return (
          <EtapaFormaPgtoComponent
            formaPgto={formaPgtoSelecionada}
            onChangeFormaPgto={(formaPgto, index) => handleChangeFormaPgto(formaPgto, index)}
            itens={props.itens}
            calculoTotalItens={calcTotalItens()}
            isDinheiro={isDinheiro}
            vlrTroco={formaPagamento?.vlrTroco}
            onChangeTroco={(formaPgto: number) => handleChangeTroco(formaPgto)}
          />
        );

      case "CONFIRMACAO":
        return (
          //<ConfirmacaoPedidoComponent />
          <p>PEDIDO CONFIRMADO!</p>
        );

      default:
        return null;
    }
  };

  const getButtonLabel = () => {
    switch (step) {
      case "CARRINHO":
        return "Próximo";

      case "USUARIO":
        return "Próximo";

      case "ENDERECO":
        return "Próximo";

      case "PAGAMENTO":
        return "Finalizar pedido";

      default:
        return "Continuar";
    }
  };

  const checkDadosPreenchidos = () => {
    switch (step) {
      case "CARRINHO":
        return props.itens.length > 0;

      case "USUARIO":
        return cliente !== undefined && (cliente.telefoneCompleto !== "" || cliente.nome !== "");

      case "ENDERECO":
        return endereco !== undefined;

      case "PAGAMENTO":
        return formaPagamento !== undefined;

      default:
        return false;
    }
  }

  const listagemItensCarrinho = () => {
    return <CarrinhoPaperComponent
      component={renderStepContent()}
      //onChangeItens={(prev: any[]) => setItens}
      onChangeOpenCarrinho={() => {
        setOpenCarrinho(!openCarrinho);
        setStep("CARRINHO");
      }}
      buttonLabel={getButtonLabel()}
      onClickFooter={nextStep}
      disabled={!checkDadosPreenchidos()}
    />
  }

  const getDadosUsuario = async (telefone: string) => {
    var usuarioTemp: Usuario = {
      ...cliente,
      telefone: "",
      telefoneCompleto: telefone,
      nome: ""
    }

    setBloqueiaCampoUsuario(true);

    if (telefone.length >= 15) {
      try {
        const response = await usuarioService.getUsuarioAutocomplete(telefone);
        usuarioTemp = response;
        //setUsuario({...usuario, nome: "nome"});
      } catch (err: any) {
        console.error(err)
        if (err.status) {
          if (err.status == 404) setBloqueiaCampoUsuario(false);
        }
        else alert("Erro ao buscar usuário.");
      }
    }

    setCliente(usuarioTemp);
    localStorage.setItem("cliente", JSON.stringify(usuarioTemp));
  }

  return (
    <BoxComponent component="div" sx={{
      display: "flex"
    }}>
      {openCarrinho && listagemItensCarrinho()}

      {!openCarrinho && <ButtonComponent id="botao-itens-carrinho"
        type="button"
        onClick={handleClickCarrinho}
        sx={{
          position: 'fixed',
          bottom: {
            xs: 67,
            sm: 80
          },
          right: {
            xs: 40,
            sm: 60,
          },
          display: {
            xs: "flex",
            sm: 'flex'
          },
          flexDirection: 'column',
          zIndex: 1200,
          border: '1px solid',
          borderColor: 'divider',

          minWidth: 45,
          width: 45,
          height: 45,
          maxHeight: 45,
          borderRadius: "100%",
          opacity: 1,
          backgroundColor: "#E7000B",
          color: "#FFFFFF",
          "&": {
            position: 'fixed',
          }
        }}
      >
        <SvgComponent
          icon={<CarrinhoIcon />}
          sx={{
            display: "flex",
            alignpropss: "center",
            justifyContent: "center",
            height: 18,
            width: 18,
            "& svg, & svg *": {
              fill: "#FFFFFF",
              stroke: "#FFFFFF",
            },
          }}
        />

        {props.itens.length > 0 && (
          <TypographyComponent
            sx={{
              position: "absolute",
              top: -6,
              right: -6,
              zIndex: 2000,

              width: 24,
              height: 24,

              borderRadius: '50%',
              backgroundColor: '#FDC700',

              fontFamily: '"Font 7", sans-serif',
              fontWeight: 700,
              fontSize: '12px',
              lineHeight: '16px',
              color: '#C10007',

              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',

              boxSizing: 'border-box',
            }}
          >
            {props.itens.length}
          </TypographyComponent>
        )}
      </ButtonComponent>
      }
    </BoxComponent >
  );
};

export default CarrinhoComponent;